import React from 'react'
import { FC, useState } from "react";
import {Link} from "react-router-dom"
import AirplanemodeActive from '@mui/icons-material/AirplanemodeActive';
import CommentIcon from '@mui/icons-material/Comment';
import MapIcon from '@mui/icons-material/Map';
import EmailIcon from '@mui/icons-material/Email';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HouseIcon from '@mui/icons-material/House';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import InstagramIcon from '@mui/icons-material/Instagram';
import '../App.css';

export default function Header() {
  const [open, setOpen] = useState<boolean>(false);
  const toggleFunction = () => {
    setOpen(!open);
  };
  return (
   <>
        <div className='navbar'>
          <Link to = '#' className='menu-bars'>
            <MenuIcon onClick={toggleFunction}/>
          </Link>
         <div className='wrapper'>
          <h1>My Trip History</h1>
         </div>
        </div>
        <nav className={open ? 'nav-menu active' : 'nav-menu'}>
            <ul className='nav-menu-items' onClick={toggleFunction}>
              <li className='navbar-toggle'>
               <Link to='#' className='menu-bars'>
                 <CloseIcon/>
               </Link>
              </li>
              <li className='nav-text'>
                <HouseIcon/>
                <Link to="/">トップ</Link>
              </li>
              <li className='nav-text'>
                <AirplanemodeActive/>
                <Link to="/Post">投稿</Link>
              </li>
              <li className='nav-text'>
                <NoteAltIcon/>
                <Link to="/Plan">計画</Link>
              </li>              
              <li className='nav-text'>
                <MapIcon/>
               <Link to ="Map">スポット一覧</Link>
              </li>
              <li className='nav-text'>
                <EmailIcon/>
                <Link to ="Help">お問い合わせ</Link>
              </li>
            </ul>
        </nav>
    </>
  )
}
